export const toastSetShowMessage = (id, message) => ({
  type: 'TOAST_SET_SHOW_MESSAGE',
  id,
  message,
});
